// extracted by mini-css-extract-plugin
export default {"modalSlideUp":"Modals_modalSlideUp__Ajppw","slideUp":"Modals_slideUp__g+H8-","modalSlideDown":"Modals_modalSlideDown__a5QOE","slideDown":"Modals_slideDown__+ioxx"};